// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.header-input .m-input-date[data-v-d5b7ee3a] {\n  padding: 0.84rem 1.5rem;\n}\n.input-icon[data-v-d5b7ee3a] {\n  width: 3.2rem;\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  right: 0;\n  display: flex;\n}\n.input-icon > i[data-v-d5b7ee3a] {\n  font-size: 1.125rem;\n  margin: auto;\n  display: block;\n  color: var(--white);\n}\n", ""]);
// Exports
module.exports = exports;
